import { Component, Input, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import storeeeee from 'store'
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { NzMessageService } from 'ng-zorro-antd/message'
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal'
import { NzUploadChangeParam, NzUploadFile, NzUploadXHRArgs } from 'ng-zorro-antd/upload'
import {
  HttpClient,
  HttpEventType,
  HttpHeaders,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http'
import { ApiService } from 'src/app/services/api.service'
import { Observable, Observer } from 'rxjs'
import { OnMitraService } from 'src/app/services/on-mitra.service'
import { MitraForm } from 'src/app/services/interface/on-mitra.model'

const getBase64 = (file: File): Promise<string | ArrayBuffer | null> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })

@Component({
  selector: 'app-edit-verified',
  templateUrl: './edit-verified.component.html',
})
export class EditVerifiedComponent implements OnInit {
  @Input() id: string

  form: FormGroup
  fileList: { [key: string]: NzUploadFile[] } = {
    profile_img: [],
    ktp_img: [],
    kk_img: [],
    sim_img: [],
    stnk_img: [],
    skck_img: [],
    sks_img: [],
    npwp_img: [],
  }

  list = [
    'profile_img',
    'ktp_img',
    'kk_img',
    'sim_img',
    'stnk_img',
    'sks_img',
    'npwp_img',
    'skck_img',
  ]

  constructor(
    private fb: FormBuilder,
    private mitraService: OnMitraService,
    private apiService: ApiService,
    private notification: NzNotificationService,
    private msg: NzMessageService,
    private modalService: NzModalService,
    private modal: NzModalRef,
    private http: HttpClient,
  ) {
    this.form = this.fb.group({
      email: [null, Validators.compose([Validators.required])],
      password: [null],
      first_name: [null, Validators.compose([Validators.required])],
      last_name: [null, Validators.compose([Validators.required])],
      gender: [null, Validators.compose([Validators.required])],
      date_of_birth: [null, Validators.compose([Validators.required])],
      phoneNumberPrefix: ['+62'],
      phone_number: [null, Validators.compose([Validators.required])],
      disabled: [null, Validators.compose([Validators.required])],
      plat_no: [null, Validators.compose([Validators.required])],
      vehicle_type: [null, Validators.compose([Validators.required])],
      npwp_no: [null, Validators.compose([Validators.required])],
      profile_img: [null, Validators.compose([Validators.required])],
      ktp_img: [null, Validators.compose([Validators.required])],
      kk_img: [null, Validators.compose([Validators.required])],
      sim_img: [null, Validators.compose([Validators.required])],
      stnk_img: [null, Validators.compose([Validators.required])],
      skck_img: [null, Validators.compose([Validators.required])],
      sks_img: [null, Validators.compose([Validators.required])],
      npwp_img: [null, Validators.compose([Validators.required])],
      balance: [null, Validators.compose([Validators.required])],
      join_date: [null, Validators.compose([Validators.required])],
      last_job: [null, Validators.compose([Validators.required])],
      imei: [null],
      verified_by: [null],
      updated_by: [null],
      disabled_by: [null],
    })
  }

  disabled: any
  updatedBy: string
  email: string
  isLoading: boolean = true
  ngOnInit(): void {
    this.fetchMitraDetails()
    for (const i in this.form.controls) {
      if (this.form.controls.hasOwnProperty(i)) {
        this.form.controls[i].markAsDirty()
        this.form.controls[i].updateValueAndValidity()
      }
    }
    this.form.statusChanges.subscribe(state => {
      this.modal.updateConfig({ nzOkDisabled: state === 'INVALID' })
    })
  }

  fetchMitraDetails() {
    this.isLoading = true
    this.mitraService.detailVerified(this.id).subscribe(
      res => {
        this.disabled = res.disabled
        this.updatedBy = res.updated_by
        this.email = res.email
        this.fileList['profile_img'] = [res.profile_img]
        this.fileList['ktp_img'] = [res.ktp_img]
        this.fileList['kk_img'] = [res.kk_img]
        this.fileList['sim_img'] = [res.sim_img]
        this.fileList['stnk_img'] = [res.stnk_img]
        this.fileList['skck_img'] = [res.skck_img]
        this.fileList['sks_img'] = [res.sks_img]
        this.fileList['npwp_img'] = [res.npwp_img]
        res.profile_img = true
        res.ktp_img = true
        res.sim_img = true
        res.kk_img = true
        res.stnk_img = true
        res.skck_img = true
        res.sks_img = true
        res.npwp_img = true
        this.form.patchValue(res)
        this.isLoading = false
        for (const i in this.form.controls) {
          if (this.form.controls.hasOwnProperty(i)) {
            this.form.controls[i].markAsDirty()
            this.form.controls[i].updateValueAndValidity()
          }
        }
      },
      err => {
        this.notification.error('Error', err.error.message)
      },
    )
  }

  cancel(): void {
    this.modal.destroy()
  }

  submitForm(): void {
    this.isLoading = true
    var isUploading = false
    //looping object
    for (var i in this.fileList) {
      for (let j = 0; j < this.fileList[i].length; j++) {
        if (['uploading', 'error'].includes(this.fileList[i][j].status)) {
          isUploading = true
          break
        }
      }
      if (isUploading) break
    }

    for (const i in this.form.controls) {
      if (this.form.controls.hasOwnProperty(i)) {
        this.form.controls[i].markAsDirty()
        this.form.controls[i].updateValueAndValidity()
      }
    }
    if (!isUploading && this.form.valid) {
      var formSubs: MitraForm = this.form.value
      formSubs.id = this.id
      if (formSubs.email != null || formSubs.email != undefined) {
        this.email = formSubs.email
      }

      Object.keys(this.fileList).forEach(r => {
        if (this.fileList[r][0].status === 'done') {
          formSubs[r] = {
            status: this.fileList[r][0].status,
            name: this.fileList[r][0].response?.name || this.fileList[r][0].name,
            url: this.fileList[r][0].response?.url || this.fileList[r][0].url,
            uid: this.fileList[r][0].uid,
          }
        }
      })

      this.mitraService.updateVerified(formSubs).subscribe(
        r => {
          this.notification.success('Success', r.message)
          this.isLoading = false
          this.modal.destroy()
        },
        err => {
          console.log(err)
          this.notification.error('Error', err.error.message)
          this.isLoading = false
        },
      )
    } else {
      this.msg.error(
        isUploading ? 'Please wait until all files uploaded' : 'Please Fill Blank Form',
      )
      this.isLoading = false
      this.modal.updateConfig({ nzOkLoading: this.isLoading, nzCancelDisabled: this.isLoading })
      return
    }
  }

  resetPassword() {
    this.modalService.confirm({
      nzTitle: 'Are you sure you want to reset the password of this mitra?',
      nzContent: '<b style="color: red;">This Action cannot be undone !</b>',
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOnOk: () => {
        this.mitraService.resetPassword(this.id).subscribe(
          r => {
            this.notification.success('Success', r.message)
            this.fetchMitraDetails()
          },
          err => {
            this.notification.error('Error', err.error.message)
          },
        )
      },
      nzCancelText: 'No',
      // nzOnCancel: () => console.log('Cancel'),
    })
  }

  resetUniqueKey() {
    this.modalService.confirm({
      nzTitle: 'Are you sure you want to reset the unique key of this mitra?',
      nzContent: '<b style="color: red;">This Action cannot be undone !</b>',
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOnOk: () => {
        this.mitraService.resetUniqueKey(this.id).subscribe(
          r => {
            this.notification.success('Success', r.message)
            this.fetchMitraDetails()
          },
          err => {
            this.notification.error('Error', err.error.message)
          },
        )
      },
      nzCancelText: 'No',
      // nzOnCancel: () => console.log('Cancel'),
    })
  }

  handleBeforeUpload = (file: NzUploadFile): boolean => {
    if (file.size <= 11534336) {
      return true
    } else {
      this.msg.error('File too Large')
      return false
    }
  }

  customUploadReq(type: string) {
    return (item: NzUploadXHRArgs) => {
      const formData = new FormData()
      formData.append(type, item.file as any)

      const req = new HttpRequest(
        'POST',
        this.apiService.API_SUNSHINE_SERVER + '/api/upload/temp/on_mitra',
        formData,
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + storeeeee.get('accessToken'),
          }),
          reportProgress: true,
          withCredentials: false,
        },
      )

      return this.http.request(req).subscribe(
        (event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            if (event.total > 0) {
              ;(event as any).percent = (event.loaded / event.total) * 100 // tslint:disable-next-line:no-any
            }
            item.onProgress!(event, item.file)
          } else if (event instanceof HttpResponse) {
            item.onSuccess!(event.body, item.file, event)
          }
        },
        err => {
          console.log(err)
          /* error */
          item.onError!(err, item.file)
        },
      )
    }
  }

  handleRemove = (file: NzUploadFile) =>
    new Observable((observer: Observer<boolean>) => {
      this.form.patchValue({ image: null })
      observer.next(true)
      observer.complete()
    })

  handleDownload = (file: NzUploadFile): void => {
    window.open((file.response?.url || file.url) + '?s=download', '_blank')
  }

  previewImage: string | undefined = ''
  previewVisible = false

  handlePreview = async (file: NzUploadFile): Promise<void> => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj!)
    }
    this.previewImage = file.response?.url || file.url || file.preview
    this.previewVisible = true
  }

  handleChange(info: NzUploadChangeParam, type: string) {
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`)
      if (type === 'profile_img') {
        this.form.patchValue({ profile_img: true })
      }
      if (type === 'ktp_img') {
        this.form.patchValue({ ktp_img: true })
      }
      if (type === 'kk_img') {
        this.form.patchValue({ kk_img: true })
      }
      if (type === 'sim_img') {
        this.form.patchValue({ sim_img: true })
      }
      if (type === 'stnk_img') {
        this.form.patchValue({ stnk_img: true })
      }
      if (type === 'skck_img') {
        this.form.patchValue({ skck_img: true })
      }
      if (type === 'sks_img') {
        this.form.patchValue({ sks_img: true })
      }
      if (type === 'npwp_img') {
        this.form.patchValue({ npwp_img: true })
      }
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`)
    }
  }
}
